import DialogTitle from '@material-ui/core/DialogTitle';

import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'

import { hideDialog } from './actions'

import { v4 } from 'uuid'

import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import './dialog.css'

class DialogComponet extends Component {
  constructor() {
    super();

    this.state = {
      nameInputValue: ""
    }

  }

  handleClose = () => {

    this.props.hideDialog()
  }

  updateText = (event) => {

    this.setState({
      nameInputValue: event.target.value
    })

  }

  nameKeyPress = (event) => {

    var {nameInputValue} = this.state

    if (event.keyCode == 13 && nameInputValue && nameInputValue.length) {

      this.props.getTwillioToken(nameInputValue)

      this.setState({
        nameInputValue: ""
      })

    }

  }
  render() {

    var dialog = this.props.dialog

    var {show, showloader} = dialog

    return (
      <div>
        { show &&
          <div style={ { top: 0, left: 0, position: "absolute" } } className="h-100 animated fadeIn w-100 d-flex justify-content-center align-items-center">
            <div onClick={ (event) => this.handleClose() } className="login-fade h-100 w-100">
            </div>
            { showloader &&
              
              <div className="d-flex justify-content-center align-items-center" style={ { zIndex: 10, backgroundColor: 'white', height: 200, width: 200 } }>
                <CircularProgress color="secondary" />
              </div> }
          </div> }
      </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => ({
  dialog: state.dialog
})

const Dialog = connect(mapStateToProps, {
  hideDialog
})(DialogComponet)

export default Dialog


// WEBPACK FOOTER //
// ./src/Components/DialogComponent/index.js